import classes from "./CarCard.module.css";
import CustomIcon from "../../CustomIcons/CustomIcon";
import CustomMenu from "../../Menus/CustomMenu/CustomMenu";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { MenuItemEntity } from "../../../../entities/UIEntities/MenuItem";
import { MENU_ITEMS, ROLES_HIERARCHY } from "../../../../enums/Enums";
import Icons from "../../../../resources/icons/Icons";
 import Strings from "../../../../resources/Strings";
import { handleDeleteCar, handleEditCar } from "../../../../utils/MenuUtils";
import { useSelector } from "react-redux";
import { isAllowedForActionsOnUser } from "../../../../utils/UsersUtils";

const CarCard = (props) => {
  const gmtUser = useSelector((state) => state.user?.gmtUser);
  const roles = useSelector((state) => state.user?.initialState)?.roles;
  const parkerSelectionModel = useSelector((state) => state.user.parkerSelectionModel);
  const canMakeActions = isAllowedForActionsOnUser(roles, parkerSelectionModel, gmtUser);
  const validRole = useSelector((state) => state.user.gmtUser?.role?.hierarchy) <= ROLES_HIERARCHY.COLLABORATOR;
  const carsToken = props;
  const menuItems = [
    new MenuItemEntity(MENU_ITEMS.EDIT, handleEditCar, true, Icons.EDIT_ITEM, false, carsToken),
    new MenuItemEntity(
      MENU_ITEMS.DELETE,
      handleDeleteCar,
      false,
      Icons.DELETE_ITEM,
      true,
      carsToken
    ),
  ];
  return (
    <div key={carsToken?.id} className={classes.carCardGroup}>
      <div className={classes.carCard}>
        <div>
          {carsToken?.car && (
            <div className={classes.car}>
              {!props.isViewMode && carsToken.car.isCheckIn && (
                <RadioButtonCheckedIcon className={classes.greenIcon} />
              )}
              {!props.isViewMode && !carsToken.car.isCheckIn && (
                <RadioButtonCheckedIcon className={classes.redIcon} />
              )}
              <div className={classes.userDeatils}>
                <div>
                  <div className={classes.userDeatils}>
                    <div className={classes.nickname}>
                      {carsToken.car.nickname}
                    </div>
                  </div>
                  <div className={classes.carDetails}>
                    <div>
                      {carsToken.car.licensePlate} {carsToken.car.manufacturer}
                    </div>
                  </div>
                </div>
                {carsToken.car.isEVSupported && (
                  <CustomIcon className={classes.icon} img={Icons.Electric} />
                )}
                {carsToken.car.isWheelchairAccess && (
                  <CustomIcon className={classes.icon} img={Icons.WCA} />
                )}
              </div>
            </div>
          )}
          {!carsToken?.car && (
            <div className={classes.car}>
              <RadioButtonCheckedIcon className={classes.redIcon} />
              <div className={classes.noCar}>{Strings.NO_CAR_SUBSCRIBED}</div>
            </div>
          )}
        </div>
      </div>
      <div className={classes.carToken}>
        {props.isViewMode && <span className={classes.carTokenDisplayValue}>{props?.token?.displayValue}</span>}
        <span className={classes.carTokenDisplayValue}>{carsToken?.car?.assignCarToken?.find((assignCarToken) => assignCarToken.siteId === props.parentSite.id) ? carsToken?.car?.assignCarToken?.find((assignCarToken) => assignCarToken.siteId === props.parentSite.id).displayValue : ""}</span>
        {!carsToken?.car && <span className={[classes.carTokenDisplayValue, classes.tokenDisplayMargin].join(' ')}>{props.displayValue}</span>}
        {!props.isViewMode && validRole && canMakeActions && carsToken?.car && <CustomMenu menuItems={menuItems}></CustomMenu>}
      </div>
    </div>
  );
};

export default CarCard;
